import { Icon } from './Icon'

/**
 * Состояние геолокации.
 *
 * ── Почему это не опция ───────────────────────────────────────────
 *
 * Водитель обязан видеть, что его положение записывают. Скрытый
 * трекинг в приложении, которым человек пользуется по работе, —
 * это не «незаметная функция», а подорванное доверие ко всему
 * продукту разом, и вопрос тут не только этический.
 *
 * ── Почему показывается источник, а не «вкл/выкл» ─────────────────
 *
 * «Геолокация включена» ничего не говорит: в подземном паркинге она
 * включена и бесполезна. Водитель должен понимать, попадёт ли точка
 * в акт и почему её может не быть, — иначе на разборе он услышит
 * «а где вы её взяли» и не сможет ответить.
 *
 * Тот же компонент показывает источник администратору в карточке
 * поездки: обе стороны спора видят одну и ту же формулировку,
 * а не каждый свою.
 */

const STATES = {
  gps: {
    label: 'Место записано',
    detail: 'Точный сигнал',
    tone: 'ok',
    icon: 'map',
  },
  network: {
    label: 'Место записано',
    detail: 'По сети, приблизительно',
    tone: 'ok',
    icon: 'map',
  },
  cached: {
    label: 'Место записано приблизительно',
    detail: 'Последняя известная точка — сигнала сейчас нет',
    tone: 'warn',
    icon: 'map',
  },
  none: {
    label: 'Место не записано',
    detail: 'Нет сигнала. На приёмку это не влияет',
    tone: 'muted',
    icon: 'warning',
  },
  off: {
    label: 'Геолокация выключена',
    detail: 'Разрешите доступ, чтобы место фиксировалось',
    tone: 'muted',
    icon: 'warning',
  },
}

/**
 * @param {'gps'|'network'|'cached'|'none'|'off'|null} source
 * @param {boolean} compact — строка вместо блока, для плотных мест
 */
export function GeoStatus({ source, accuracy = null, compact = false, className = '' }) {
  const state = STATES[source] || STATES.none

  const detail = accuracy && (source === 'gps' || source === 'network')
    ? `${state.detail} · ±${Math.round(accuracy)} м`
    : state.detail

  return (
    <div
      className={[
        'geo-status',
        `geo-status--${state.tone}`,
        compact ? 'geo-status--compact' : '',
        className,
      ].join(' ').trim()}
      role="status"
    >
      <Icon name={state.icon} size={compact ? 13 : 16} />
      <div className="geo-status__text">
        <span className="geo-status__label">{state.label}</span>
        {!compact && <span className="geo-status__detail">{detail}</span>}
      </div>
    </div>
  )
}
